import type { MailboxInfo } from 'owa-client-types';
import { action } from 'satcheljs';

const onSwitchMailboxM365Acquisitions = action(
    'onSwitchMailboxM365Acquisitions',
    (mailboxInfo: MailboxInfo) => ({ mailboxInfo })
);

export default onSwitchMailboxM365Acquisitions;
